import React from 'react';
import {Button, CircularProgress, Divider, Grid, LinearProgress, Paper, Typography, withStyles} from "material-ui";
import {connect} from "react-redux";
import {closeGetTaskFetch, getTask} from "../../../redux/actions/tasks";
import {closeCreatePostFetch, closeGetPostsFetch, createPost, getPosts} from "../../../redux/actions/posts";
import Moment from 'react-moment';
import {PostForm} from "../../../forms/post";
import {Send} from "material-ui-icons";

const priorities = [
    '高優先', '通常', '低優先'
];

export class TaskDetailContainer extends React.Component {

    componentDidMount() {
        this.props.getTask(this.props.match.params.id);
        this.props.getPosts(this.props.match.params.id);
    }

    onSubmitCallback = (values) => {
        values = {
            ...values,
            status: 1,
            user_id: this.props.currentUser.id,
        };
        this.props.createPost(values, this.props.match.params.id, (response) => {
            switch (response.type) {
                case 'API_CREATE_POST_SUCCESS':
                    this.props.getPosts(this.props.match.params.id);
                    break;
                default:
                    break;
            }
        });
    };

    onSubmitClick = () => {
        this.refs.postForm.submit();
    };

    onTaskClose = () => {
        let values = {
            status: 2,
            comment: '_task_close',
            user_id: this.props.currentUser.id,
        };
        this.props.createPost(values, this.props.match.params.id, (response) => {
            switch (response.type) {
                case 'API_CREATE_POST_SUCCESS':
                    this.props.getTask(this.props.match.params.id);
                    this.props.getPosts(this.props.match.params.id);
                    break;
                default:
                    break;
            }
        });
    };

    onTaskOpen = () => {
        let values = {
            status: 3,
            comment: '_task_open',
            user_id: this.props.currentUser.id,
        };
        this.props.createPost(values, this.props.match.params.id, (response) => {
            switch (response.type) {
                case 'API_CREATE_POST_SUCCESS':
                    this.props.getTask(this.props.match.params.id);
                    this.props.getPosts(this.props.match.params.id);
                    break;
                default:
                    break;
            }
        });
    };

    render() {

        const {classes, task, posts, errors, isGetTaskFetch, isGetPostsFetch, isCreatePostFetch} = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.header}>
                    {isGetTaskFetch ? <CircularProgress/> :
                        <Grid container direction="column">
                            <Grid item className={classes.taskName}>
                                {task.name}
                                <Typography variant="caption">
                                    {task.detail}
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                </div>

                <Grid container>
                    <Grid item xs={8}>
                        <Paper>
                            {isGetPostsFetch ? <LinearProgress/> : null}
                            <div className={classes.container}>

                                {posts.map((n) => {
                                    return <div key={n.id}>
                                        <div className={classes.messageBlock}>
                                            {n.status === 1 ?
                                                <div>
                                                    <div>
                                                        <span className={classes.userName}>{n.user.name}</span>
                                                        <span className={classes.postDate}>
                                                    <Moment format="MM/DD HH:mm">{n.created_at}</Moment>
                                                </span>
                                                    </div>


                                                    <div>
                                                        {n.comment.split("\n").map((row, index) => {
                                                            return row === '' ? <br key={index}/>
                                                                : <p key={index} className={classes.message}>{row}</p>
                                                        })}
                                                    </div>

                                                </div>
                                                : null}

                                            {n.status === 2 ?
                                                <div>

                                                    <Grid container alignItems="center">
                                                        <Grid item>
                                                            <div className={classes.closeTaskContainer}>
                                                                <span className={classes.closeTask}>課題終了</span>
                                                            </div>
                                                        </Grid>
                                                        <Grid item>
                                                            <Moment format="MM/DD HH:mm"
                                                                    className={classes.taskMessageDate}>
                                                                {n.created_at}
                                                            </Moment><br/>
                                                            <span className={classes.taskMessage}>
                                                                {n.user.name}さんが課題を閉じました
                                                                </span>
                                                        </Grid>
                                                    </Grid>
                                                </div> : null}

                                            {n.status === 3 ?
                                                <div>

                                                    <Grid container alignItems="center">
                                                        <Grid item>
                                                            <div className={classes.openTaskContainer}>
                                                                <span className={classes.closeTask}>オープン</span>
                                                            </div>
                                                        </Grid>
                                                        <Grid item>
                                                            <Moment format="MM/DD HH:mm"
                                                                    className={classes.taskMessageDate}>
                                                                {n.created_at}
                                                            </Moment><br/>
                                                            <span className={classes.taskMessage}>
                                                                {n.user.name}さんが課題を再開しました
                                                                </span>
                                                        </Grid>
                                                    </Grid>
                                                </div> : null}

                                            {n.status === 4 ?
                                                <div>

                                                    <Grid container alignItems="center">
                                                        <Grid item>
                                                            <div className={classes.openTaskContainer}>
                                                                <span className={classes.closeTask}>オープン</span>
                                                            </div>
                                                        </Grid>
                                                        <Grid item>
                                                            <Moment format="MM/DD HH:mm"
                                                                    className={classes.taskMessageDate}>
                                                                {n.created_at}
                                                            </Moment><br/>
                                                            <span className={classes.taskMessage}>
                                                                {n.user.name}さんが課題を作成しました
                                                                </span>
                                                        </Grid>
                                                    </Grid>
                                                </div> : null}
                                        </div>
                                        <Divider/>
                                    </div>
                                })}

                                {isCreatePostFetch ? <LinearProgress/> : null}

                                <div className={classes.postField}>
                                    <PostForm
                                        ref="postForm"
                                        errors={errors}
                                        onSubmit={this.onSubmitCallback}/>

                                    <Grid container justify="flex-end" alignItems="center">
                                        {task.status === 2 ?
                                            <Grid item>
                                                <Button
                                                    color="default"
                                                    onClick={this.onTaskOpen.bind(this)}>課題を開く</Button>
                                            </Grid>
                                            : null}
                                        {task.status === 1 ?
                                            <Grid item>
                                                <Button
                                                    color="default"
                                                    onClick={this.onTaskClose.bind(this)}>課題を閉じる</Button>
                                            </Grid>
                                            : null}
                                        <Grid item>
                                            <Button variant="raised"
                                                    color="primary"
                                                    onClick={this.onSubmitClick.bind(this)}>送信
                                                <Send className={classes.buttonIcon}/></Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.rightContainer}>
                            {isGetTaskFetch ? <CircularProgress/> :
                                <div>

                                    <dl>
                                        <dt className={classes.detailTitle}>ステータス</dt>

                                        <dd className={classes.detailDescriptionStatus}>
                                            {task.status === 1 ?
                                                <div className={classes.detailOpenStatus}>
                                                    <span className={classes.detailTaskName}>オープン</span>
                                                </div>
                                                : null}
                                            {task.status === 2 ?
                                                <div className={classes.detailCloseStatus}>
                                                    <span className={classes.detailTaskName}>課題終了</span>
                                                </div>
                                                : null}
                                        </dd>
                                    </dl>

                                    <dl>
                                        <dt className={classes.detailTitle}>担当者</dt>
                                        {task.pic !== undefined ?
                                            <dd className={classes.detailDescription}>{task.pic.name}</dd>
                                            : null}
                                    </dl>
                                    <dl>
                                        <dt className={classes.detailTitle}>優先度</dt>
                                        <dd className={classes.detailDescription}>
                                            {priorities[task.priority - 1]}
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt className={classes.detailTitle}>期日</dt>
                                        <dd className={classes.detailDescription}>
                                            <Moment format="YYYY年MM月DD日">{task.limited_at}</Moment>
                                        </dd>
                                    </dl>

                                    <dl>
                                        <dt className={classes.detailTitle}>課題作成日</dt>
                                        <dd className={classes.detailDescription}>
                                            <Moment format="YYYY年MM月DD日">{task.created_at}</Moment>
                                        </dd>
                                    </dl>
                                </div>
                            }
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        )
    }

}

const styles = theme => ({
    root: {
        padding: theme.spacing.unit * 3,
        background: '#fbfbfb',
        minHeight: `calc(100vh - 64px - ${theme.spacing.unit * 3 * 2}px)`,
    },
    subtitle: {
        marginBottom: theme.spacing.unit,
    },
    header: {
        marginBottom: theme.spacing.unit * 3,
    },
    headerContainer: {
        padding: theme.spacing.unit * 3,
    },
    container: {
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 5,
    },
    messageBlock: {
        paddingTop: theme.spacing.unit * 3,
        paddingBottom: theme.spacing.unit * 3,
    },
    message: {
        marginTop: 1,
        marginBottom: 0,
    },
    postField: {
        paddingTop: theme.spacing.unit * 3,
        paddingBottom: theme.spacing.unit * 3,
    },
    userName: {
        fontWeight: 'bold',
        fontSize: 14,
        marginRight: theme.spacing.unit,
    },
    companyName: {
        fontSize: 13,
        color: '#8e8c8c',
    },
    postDate: {
        fontSize: 13,
        color: '#8e8c8c',
    },
    rightContainer: {
        position: 'sticky',
        top: 88,
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3,
    },
    detailTitle: {
        color: '#8e8c8c',
        fontSize: 12,
    },
    detailDescriptionStatus: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
    },
    detailDescription: {
        marginLeft: 0,
    },
    buttonIcon: {
        marginLeft: theme.spacing.unit,
    },
    openTaskContainer: {
        background: '#009688',
        borderRadius: 5,
        display: 'inline',
        padding: theme.spacing.unit,
    },
    closeTaskContainer: {
        background: '#F44336',
        borderRadius: 5,
        display: 'inline',
        padding: theme.spacing.unit,
    },
    closeTask: {
        color: "#fff",
        fontSize: 14,
    },
    taskMessageDate: {
        fontSize: 12,
        color: '#8e8c8c',
    },
    taskMessage: {
        fontSize: 14,
    },
    taskName: {
        fontSize: 24,
    },
    detailOpenStatus: {
        marginTop: theme.spacing.unit,
        background: '#009688',
        borderRadius: 5,
        display: 'inline',
        padding: theme.spacing.unit,
    },
    detailCloseStatus: {
        background: '#F44336',
        borderRadius: 5,
        display: 'inline',
        padding: theme.spacing.unit,
    },
    detailTaskName: {
        fontSize: 13,
        color: '#fff',
    },
});

TaskDetailContainer = withStyles(styles)(TaskDetailContainer);

TaskDetailContainer = connect(
    (state) => {
        return {
            isGetTaskFetch: state.tasks.isGetTaskFetch,
            isGetPostsFetch: state.posts.isGetPostsFetch,
            isCreatePostFetch: state.posts.isCreatePostFetch,
            task: state.tasks.task,
            posts: state.posts.posts,
            errors: state.posts.errors,
            currentUser: state.users.currentUser,
        }
    },
    (dispatch) => {
        return {
            getTask: (taskId) => {
                dispatch(getTask(taskId)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetTaskFetch());
                    }, 300);
                });
            },
            getPosts: (taskId) => {
                dispatch(getPosts(taskId)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetPostsFetch());
                    }, 300);
                });
            },
            createPost: (post, taskId, callback) => {
                dispatch(createPost(post, taskId)).then((response) => {
                    setTimeout(() => {
                        callback(response);
                        dispatch(closeCreatePostFetch());
                    }, 300);
                });
            },
        }
    }
)(TaskDetailContainer);


// WEBPACK FOOTER //
// ./src/containers/task/detail/index.js